"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
const familyHealthcareImage = "/assets/services-family-healthcare.jpg";
const businessTeamImage = "/assets/team-mechanic.jpg";

const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      title: t("services.individualsTitle"),
      description: t("services.individualsDesc"),
      image: familyHealthcareImage,
      imageAlt: "Mother with baby on virtual doctor visit",
      cta: t("services.individualsCta"),
      href: "/individuals",
      imageFirst: true,
    },
    {
      title: t("services.businessesTitle"),
      description: t("services.businessesDesc"),
      image: businessTeamImage,
      imageAlt: "Worker giving presentation to team",
      cta: t("services.businessesCta"),
      href: "/businesses",
      imageFirst: false,
    },
  ];

  return (
    <section className="bg-surface-card py-20 px-6 lg:px-16" id="services">
      <div className="max-w-[1000px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl lg:text-[36px] text-foreground mb-2">
            {t("services.heading")}
          </h2>
        </div>

        {/* Service Cards */}
        <div className="flex flex-col gap-12 mb-10">
          {services.map((service) => (
            <div
              key={service.title}
              className={`flex flex-col ${
                service.imageFirst ? "lg:flex-row" : "lg:flex-row-reverse"
              } gap-8 items-stretch`}
            >
              {/* Image */}
              <div className="flex-1 w-full">
                <div className="rounded-[24px] overflow-hidden h-full min-h-[280px]">
                  <img src={service.image} alt={service.imageAlt} className="w-full h-full object-cover object-top" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 w-full flex flex-col justify-center">
                <h3 className="font-heading font-bold text-xl lg:text-2xl leading-tight text-foreground mb-4">
                  {service.title}
                </h3>
                <p className="font-body text-sm text-foreground/80 mb-5 leading-relaxed">
                  {service.description}
                </p>
                <Link href={service.href} className="w-full sm:w-fit">
                  <Button
                    variant="outline"
                    className="border-accent-blue text-accent-blue hover:bg-accent-blue hover:text-white rounded-full px-6 py-3 font-button text-sm w-full sm:w-fit cta-hover cta-hover-no-ring"
                  >
                    {service.cta}
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-border" />
      </div>
    </section>
  );
};

export default Services;